import {
    REQUEST_SHIPMENTS,
    REQUEST_SHIPMENTS_FAILURE,
    REQUEST_SHIPMENTS_SUCCESS
} from "../../../constant/transaction/ShipmentConstant";

const initialState = {
    shipments: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const shipmentsReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_SHIPMENTS:
            return {
                ...state,
                shipments: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_SHIPMENTS_SUCCESS:
            return {
                ...state,
                shipments: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_SHIPMENTS_FAILURE:
            return {
                ...state,
                shipments: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
